import DoctorList from '@/views/Doctor/DoctorList'
import DoctorDetail from '@/views/Doctor/DoctorDetail'

const doctor = [
  {
    path: 'doctors',
    name: 'DoctorList',
    component: DoctorList
  },
  {
    path: 'doctors/:id',
    name: 'DoctorDetail',
    component: DoctorDetail,
    props: true
  },
];

export default doctor;



// WEBPACK FOOTER //
// ./src/router/modules/doctor.js